var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modal","title":_vm.title,"size":"md"},on:{"ok":function($event){return _vm.$emit('ok', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }